import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewportService } from '../../services/viewport.service';
import { FlowStepInterface } from '../../interfaces/flow-step.interface';

@Component({
  selector: 'app-steps-header',
  templateUrl: './steps-header.component.html',
  styleUrls: ['./steps-header.component.scss']
})
export class StepsHeaderComponent implements OnInit, OnDestroy {
  @Input() steps: FlowStepInterface[];
  @Input() currentStepIndex: number;
  private isDesktopSubscription: Subscription;
  public isDesktop: boolean;

  get justifyAroundCondition() {
    return !this.isDesktop || this.steps.length < 2;
  }

  constructor(private viewportService: ViewportService) {}

  ngOnInit() {
    this.isDesktopSubscription = this.viewportService.isDesktopObservable.subscribe((value) => {
      this.isDesktop = value;
    });
  }

  ngOnDestroy() {
    if (this.isDesktopSubscription) {
      this.isDesktopSubscription.unsubscribe();
    }
  }
}
